import { QRCodeSVG } from 'qrcode.react'
import akhiratLogoGold from '../../assets/images/akhirat-logo-gold.png'
import { getBrand } from '../../utils/brand'

interface MembershipECardProps {
  /** Internal user id — the back-face QR opens the admin detail page for it. */
  id?: string
  memberId?: string | null
  /** Virtual account number, shown digits-only in place of the member id. */
  virtualAccountNumber?: string | null
  firstName?: string | null
  lastName?: string | null
}

const GOLD = '#D4AF37'

function CardFace({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative aspect-[1.586/1] overflow-hidden rounded-xl bg-[#0B0B0C] shadow-xl ring-1 ring-[#D4AF37]/40">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-white/[0.07] via-transparent to-transparent" />
      {children}
    </div>
  )
}

export default function MembershipECard({
  id,
  memberId,
  virtualAccountNumber,
  firstName,
  lastName,
}: MembershipECardProps) {
  const fullName = `${firstName ?? ''} ${lastName ?? ''}`.trim() || '—'
  const { name: brandName } = getBrand()
  const qrValue = id ? `${window.location.origin}/admin/users/${id}` : ''

  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
      {/* Front */}
      <CardFace>
        <div className="relative flex h-full flex-col justify-between p-5">
          <div className="flex items-start justify-between">
            <div className="flex items-center gap-2.5">
              <img src={akhiratLogoGold} alt={brandName} className="h-9 w-9 object-contain" />
              <span className="font-serif text-lg tracking-[0.18em]" style={{ color: GOLD }}>
                {brandName}
              </span>
            </div>
            <span className="text-[10px] font-medium uppercase tracking-[0.25em]" style={{ color: GOLD, opacity: 0.8 }}>
              Member
            </span>
          </div>
          <div>
            <p className="font-serif text-2xl leading-tight text-neutral-100">{fullName}</p>
            <div className="mt-2 flex items-baseline justify-between gap-2">
              <span className="font-mono text-sm" style={{ color: GOLD }}>
                {virtualAccountNumber || '—'}
              </span>
              <span className="font-mono text-xs text-neutral-400">
                {memberId || '—'}
              </span>
            </div>
          </div>
        </div>
      </CardFace>

      {/* Back */}
      <CardFace>
        <div className="relative flex h-full flex-col justify-between p-5">
          <div className="flex items-start justify-between">
            <span className="text-[10px] font-medium uppercase tracking-[0.25em]" style={{ color: GOLD, opacity: 0.8 }}>
              Membership Card
            </span>
            <img src={akhiratLogoGold} alt="" aria-hidden className="h-9 w-9 object-contain opacity-80" />
          </div>
          <div className="flex items-center gap-4">
            <div className="rounded-lg bg-white p-2">
              {qrValue ? (
                <QRCodeSVG value={qrValue} size={96} fgColor="#111111" bgColor="#FFFFFF" level="M" />
              ) : (
                <div className="h-24 w-24" />
              )}
            </div>
            <div>
              <p className="text-xs font-medium leading-snug text-neutral-200">
                Scan to view
                <br />
                member profile
              </p>
              <p className="mt-1 text-[10px] uppercase tracking-wider text-neutral-500">Admin access only</p>
            </div>
          </div>
        </div>
      </CardFace>
    </div>
  )
}
